import { render, staticRenderFns } from "./pt-button.vue?vue&type=template&id=b513d5d0"
import script from "./pt-button.vue?vue&type=script&lang=js"
export * from "./pt-button.vue?vue&type=script&lang=js"
import style0 from "./pt-button.vue?vue&type=style&index=0&id=b513d5d0&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports